<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="row">
    <div class="col-24">
        <h1 class="medium">Confirm the Enrollment Details Below</h1>
    </div>
</div>
<div class="row" *ngIf="hasError">
    <div class="col-24">
        <div class="alert danger">
            <p><em>Error Message:</em></p>
            <ul>
                <li *ngFor="let error of ErrorMessages"><button>{{ error }}</button></li>
            </ul>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p class="bottom-20">Please review the following information, and click the button at the bottom of the page to submit the application for your client, or click to go back and edit details.</p>
    </div>
    <div class="col-16">
        <p class="red-text"><strong>Please note that your enrollment has not yet been submitted. Please review the data and click the submit button at the bottom of the page to complete the enrollment.</strong></p>
    </div>
</div>


<div class="row">
    <div class="col-16">
        <table class="without-stripe all-border">
            <tr>
                <td>
                    Agent ID
                </td>
                <td>
                    {{enrollment.AGENTNAME}}
                </td>
            </tr>
            <tr>
                <td>
                    Data Entry ID
                </td>
                <td>
                    {{enrollment.USERNAME}}
                </td>
            </tr>
            <tr>
                <td>
                    Title
                </td>
                <td>
                    {{enrollment.TITLE}}

                </td>
            </tr>
            <tr>
                <td>
                    First Name
                </td>
                <td>
                    {{enrollment.APPFN}}
                </td>
            </tr>
            <tr>
                <td>
                    Middle Initial
                </td>
                <td>
                    {{enrollment.APPMI}}
                </td>
            </tr>
            <tr>
                <td>
                    Last Name
                </td>
                <td>
                    {{enrollment.APPLN}}
                </td>
            </tr>
            <tr>
                <td>
                    Medicare Number
                </td>
                <td>
                    {{enrollment.HICN}}
                </td>
            </tr>
            <tr>
                <td>
                    Application Date
                </td>
                <td>
                    {{appDate}}
                </td>
            </tr>
            <tr>
                <td>
                    Effective Date
                </td>
                <td>
                    {{effDate}}
                </td>
            </tr>
            <tr>
                <td>
                    Applicant State
                </td>
                <td>
                    {{enrollment.APPST}}
                </td>
            </tr>
            <tr>
                <td>
                    Selected Plan
                </td>
                <td>
                    {{enrollment.PLANTYPENAME}}
                </td>
            </tr>
            <tr>
                <td>
                    CUID
                </td>
                <td>
                    {{enrollment.CUID}}
                </td>
            </tr>
            <tr>
                <td>
                    Carrier
                </td>
                <td>
                    {{enrollment.CARRIER}}
                </td>
            </tr>
            <tr>
                <td>
                    Account
                </td>
                <td>
                    {{enrollment.ACCOUNT}}
                </td>
            </tr>
            <tr>
                <td>
                    Group
                </td>
                <td>
                    {{enrollment.GROUP}}
                </td>
            </tr>
            <tr>
                <td>
                    Election Period
                </td>

                <td>
                    {{enrollment.ELECTION}}
                </td>
            </tr>
            <tr>
                <td>
                    Enrollment Criteria
                </td>
                <td>
                    {{enrollment.SEPREASONCD}} - {{enrollment.SEPREASONTEXT}}
                </td>
            </tr>
            <tr *ngIf="showSepEffDate">
                <td>
                    SEP Date
                </td>
                <td>
                    {{sepEffDate}}
                </td>
            </tr>
            <tr>
                <td>
                    Enrollment Type
                </td>
                <td>
                    {{enrollment.AGENTDEX}}
                </td>
            </tr>
            <tr>
                <td>
                    Phone Number
                </td>
                <td>
                    {{enrollment.APPPHONE}}
                </td>
            </tr>
            <tr>
                <td>
                    Cell Phone
                </td>
                <td>
                    {{enrollment.CELLPHONE}}
                </td>
            </tr>
            <tr>
                <td>
                    Date of Birth
                </td>
                <td>
                    {{dob}}
                </td>
            </tr>
            <tr>
                <td>
                    Sex
                </td>
                <td>
                    {{GenderType}}
                </td>
            </tr>
            <tr>
                <td>
                    Email
                </td>
                <td>
                    {{enrollment.APPEMAIL}}
                </td>
            </tr>
            <tr>
                <td>
                    Permanent Address 1
                </td>
                <td>
                    {{enrollment.APPADD1}}
                </td>
            </tr>
            <tr>
                <td>
                    Permanent Address 2
                </td>
                <td>
                    {{enrollment.APPADD2}}
                </td>
            </tr>
            <tr>
                <td>
                    Permanent City
                </td>
                <td>
                    {{enrollment.APPCITY}}
                </td>
            </tr>
            <tr>
                <td>
                    Permanent State
                </td>
                <td>
                    {{enrollment.APPST}}
                </td>
            </tr>
            <tr>
                <td>
                    Permanent Zip
                </td>
                <td>
                    {{enrollment.APPZIP}}
                </td>
            </tr>
            <tr *ngIf="visibleFrom2026">
                <td>
                    PO Box Override
                </td>
                <td>
                    {{poBoxOverride}}
                </td>
            </tr>
            <tr>
                <td>
                    Mailing Address 1
                </td>
                <td>
                    {{enrollment.MAILADD1}}
                </td>
            </tr>
            <tr>
                <td>
                    Mailing Address 2
                </td>
                <td>
                    {{enrollment.MAILADD2}}
                </td>
            </tr>
            <tr>
                <td>
                    Mailing City
                </td>
                <td>
                    {{enrollment.MAILCITY}}
                </td>
            </tr>
            <tr>
                <td>
                    Mailing State
                </td>
                <td>
                    {{enrollment.MAILST}}
                </td>
            </tr>
            <tr>
                <td>
                    Mailing Zip
                </td>
                <td>
                    {{enrollment.MAILZIP}}
                </td>
            </tr>
            <tr>
                <td>
                    Long-term Care Name
                </td>
                <td>
                    {{enrollment.LTCFACILITY}}
                </td>
            </tr>
            <tr>
                <td>
                    Long-term Care Phone
                </td>
                <td>
                    {{enrollment.LTCPHONE}}
                </td>
            </tr>
            <tr>
                <td>
                    Address of Facility
                </td>
                <td>
                    {{enrollment.LTCADD1}}
                </td>
            </tr>
            <tr>
                <td>
                    Medicare Part A Date
                </td>
                <td>
                    {{medAdate}}
                </td>
            </tr>
            <tr>
                <td>
                    Medicare Part B Date
                </td>
                <td>
                    {{medBDate}}
                </td>
            </tr>
            <tr>
                <td>
                    Premium Payment Type
                </td>
                <td>
                    {{enrollment.PWO}}
                </td>
            </tr>
            <tr>
                <td>
                    Language Preference
                </td>
                <td>
                    {{enrollment.LANG}}
                </td>
            </tr>
            <!--<tr>
        <td>
            Receives Paperless Documents
        </td>
        <td>
            {{EOBFlag}}
        </td>
    </tr>-->
            <tr>
                <td>
                    Secondary Coverage Name
                </td>
                <td>
                    {{enrollment.OTHCVRGNAME}}
                </td>
            </tr>
            <tr>
                <td>
                    Secondary Coverage ID
                </td>
                <td>
                    {{enrollment.OTHCVRGID}}
                </td>
            </tr>
            <tr>
                <td>
                    Secondary Coverage Group
                </td>
                <td>
                    {{enrollment.OTHCVRGGRP}}
                </td>
            </tr>
            <tr>
                <td>
                    Authorized Representative Name
                </td>
                <td>
                    {{enrollment.AUTHREPNAME}}
                </td>
            </tr>
            <tr>
                <td>
                    Authorized Representative Phone
                </td>
                <td>
                    {{enrollment.AUTHREPPHONE}}
                </td>
            </tr>
            <tr>
                <td>
                    Authorized Representative Relationship
                </td>
                <td>
                    {{enrollment.AUTHREPREL}}
                </td>
            </tr>
            <tr>
                <td>
                    Authorized Representative Address
                </td>
                <td>
                    {{enrollment.AUTHREPADD1}}
                </td>
            </tr>
            <tr>
                <td>
                    Authorized Representative City
                </td>
                <td>
                    {{enrollment.AUTHREPCITY}}
                </td>
            </tr>
            <tr>
                <td>
                    Authorized Representative State
                </td>
                <td>
                    {{enrollment.AUTHREPST}}
                </td>
            </tr>
            <tr>
                <td>
                    Authorized Representative Zip
                </td>
                <td>
                    {{enrollment.AUTHREPZIP}}
                </td>
            </tr>
            <ng-container *ngIf="visibleFrom2025">
                <tr>
                    <td>
                        Individual Rep Name
                    </td>
                    <td>
                        {{enrollment.INDREPNAME}}
                    </td>
                </tr>
                <tr>
                    <td>
                        Relationship to enrollee
                    </td>
                    <td>
                        {{enrollment.displayRELTOENROLL}}
                    </td>
                </tr>
                <tr>
                    <td>
                        National Producer Number
                    </td>
                    <td>
                        {{enrollment.NPN}}
                    </td>
                </tr>
            </ng-container>
            <tr>
                <td>
                    Name on Account
                </td>
                <td>
                    {{enrollment.ACCHOLDERNAME}}
                </td>
            </tr>
            <tr>
                <td>
                    Account Type
                </td>
                <td>
                    {{AccountType}}
                </td>
            </tr>
            <tr>
                <td>
                    Routing Number
                </td>
                <td>
                    {{enrollment.ROUTINGNB}}
                </td>
            </tr>
            <tr>
                <td>
                    Financial Institution
                </td>
                <td>
                    {{enrollment.FININSTNAME}}
                </td>
            </tr>
            <tr>
                <td>
                    Account Number
                </td>
                <td>
                    {{enrollment.ACCOUNTNB}}
                </td>
            </tr>
            <tr>
                <td>
                    Emergency contact
                </td>
                <td>
                    {{enrollment.EMERNAME}}
                </td>
            </tr>
            <tr>
                <td>
                    Emergency Phone Number
                </td>
                <td>
                    {{enrollment.EMERPHONE}}
                </td>
            </tr>
            <tr>
                <td>
                    Relationship to You
                </td>
                <td>
                    {{enrollment.EMERREL}}
                </td>
            </tr>
            <tr>
                <td>
                    Notes
                </td>
                <td>
                    {{enrollment.NOTES}}
                </td>
            </tr>
            <!--<tr *ngIf="visibleFrom2025">
        <td>
            Gender Identity
        </td>
        <td>
            {{enrollment.displayCurrentGender}}
        </td>
    </tr>
    <tr *ngIf="visibleFrom2025">
        <td>
            Different Gender Identity
        </td>
        <td>
            {{enrollment.CURRENTGENDEROTH}}
        </td>
    </tr>
    <tr *ngIf="visibleFrom2025">
        <td>
            Self Identify
        </td>
        <td>
            {{enrollment.displayGenderProNoun}}
        </td>
    </tr>
    <tr *ngIf="visibleFrom2025">
        <td>
            Different Self Identify
        </td>
        <td>
            {{enrollment.GENDERNPRONOUNOTH}}
        </td>
    </tr>-->
        </table>

    </div>
</div>
<div class="row">
    <div class="col-24">
        <button class="button primary" (click)="formSubmit()"> Submit My Client's Applications</button>
        <button class="button cancel" (click)="goBack()">Go Back</button>
    </div>
</div>


